// extracted by mini-css-extract-plugin
export default {"insideTooltip":"styles_insideTooltip__5gX6r"};